import { render, staticRenderFns } from "./SessionSettings.vue?vue&type=template&id=60533c73&scoped=true&"
import script from "./SessionSettings.vue?vue&type=script&lang=js&"
export * from "./SessionSettings.vue?vue&type=script&lang=js&"
import style0 from "./SessionSettings.vue?vue&type=style&index=0&id=60533c73&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60533c73",
  null
  
)

export default component.exports